import React from 'react';

// NOTE: v1 placeholder artwork. Designer pass pending.
export default function NewYearAccessory() {
  return (
    <g aria-hidden="true">
      {/* Party hat */}
      <path d="M78,98 L100,40 L122,98 Z" fill="#E5B941" />
      <path d="M86,80 L114,80" stroke="#E0290A" strokeWidth="2.5" />
      <path d="M90,68 L110,68" stroke="#E0290A" strokeWidth="2.5" />
      <circle cx="100" cy="40" r="6" fill="#F9FCF1" />
      {/* Stars on the hat */}
      <path d="M93,88 L94,85 L95,88 L98,89 L95,90 L94,93 L93,90 L90,89 Z" fill="#F9FCF1" />
      <path d="M107,75 L108,72 L109,75 L112,76 L109,77 L108,80 L107,77 L104,76 Z" fill="#F9FCF1" />
      {/* Confetti scattered */}
      <rect x="40" y="62" width="4" height="4" fill="#92D400" transform="rotate(20 42 64)" />
      <rect x="155" y="68" width="4" height="4" fill="#2E8FA1" transform="rotate(-20 157 70)" />
      <rect x="30" y="92" width="4" height="4" fill="#E89A2E" transform="rotate(45 32 94)" />
      <rect x="168" y="86" width="4" height="4" fill="#E0290A" transform="rotate(-45 170 88)" />
      <rect x="50" y="125" width="4" height="4" fill="#E5B941" transform="rotate(30 52 127)" />
      <rect x="150" y="120" width="4" height="4" fill="#92D400" transform="rotate(-15 152 122)" />
      {/* Streamers */}
      <path d="M62,75 Q66,82 60,88 Q64,94 58,100" stroke="#2E8FA1" strokeWidth="1.5" fill="none" />
      <path d="M138,75 Q134,82 140,88 Q136,94 142,100" stroke="#E0290A" strokeWidth="1.5" fill="none" />
    </g>
  );
}
